import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getGymsName, getTeachers, getTeachersSummary, getAffiliatesSummary, getBlackBeltsSummaryOrderByName, getAffiliates, getBlackBeltsSummary, getBlackBelts } from './HTTPService';
import { Dropdown } from 'primereact/dropdown';


import { getProducts } from './ProductService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
//import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/themes/nova/theme.css'
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Fieldset } from 'primereact/fieldset';

import api from '../api';
import { properties } from '../properties';
import apiFetch from '../auth/apiFetch';
//import i18n from "i18next";
import { useTranslation } from "react-i18next";


import i18next from '../i18n';
import { isValidE164, formatPhoneForDisplay } from '../utils/phone';

function Teachers() {

    let emptyAffiliate = {
        id: 0
    }

    let emptyTeacher = {
        id: '',
        affiliate: {
            name: '',
            contacts: {
                phone1: '',
                mobile: '',
                email: '',
            },
            grade: {
                level: '',
            }
        }

    };


    const { t } = useTranslation();

    const [products, setProducts] = useState(null);
    const [gymsName, setGymsName] = useState(null);
    const [teachers, setTeachers] = useState([]);
    //const [affiliates, setAffiliates] = useState(null);

    const [teacher, setTeacher] = useState(emptyTeacher);
    const [selectedTeachers, setSelectedTeachers] = useState(null);

    const [selectedGym, setSelectedGym] = useState(null);
    const [selectedAffiliate, setSelectedAffiliate] = useState(null);
    const [affiliate, setAffiliate] = useState(emptyAffiliate);

    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    //const [product, setProduct] = useState(emptyTeacher);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [affiliates, setAffiliates] = useState([]);
    const [affiliateMode, setAffiliateMode] = useState(null);

    const dialogHeader =
        affiliateMode === 'BLACK_BELT'
            ? 'Selecionar faixa preta como professor'
            : 'Selecionar afiliado como professor';

    const dialogMessage =
        affiliateMode === 'BLACK_BELT'
            ? 'Somente afiliados faixa preta aparecerão na lista.'
            : 'Todos os afiliados disponíveis aparecerão na lista.';

    useEffect(() => {
        getTeachers().then(data => setTeachers(data));
    }, []);

    useEffect(() => {
        if (!productDialog || !affiliateMode) return;

        if (affiliateMode === 'BLACK_BELT') {
            getTeachers().then(data => setTeachers(data));
        } else {
            getAffiliatesSummary().then(data => setAffiliates(data));
        }
    }, [productDialog, affiliateMode]);

    const onAffiliateChange = (e) => {
        setSelectedAffiliate(e.value);
    }

    const onGymChange = (e) => {
        setSelectedGym(e.value);
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    const openNew = async () => {
        setAffiliateMode('ALL');
        setSelectedAffiliate(null);

        setTeacher(emptyTeacher);
        setSubmitted(false);

        const data = await getAffiliatesSummary();
        setAffiliates(data);

        setProductDialog(true);
    };

    const openNewBlackBelt = async () => {
        setAffiliateMode('BLACK_BELT');
        setSelectedAffiliate(null);
        setTeacher(emptyTeacher);
        setSubmitted(false);

        const data = await getBlackBeltsSummaryOrderByName();
        setAffiliates(data);

        setProductDialog(true);
    };
    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const hideDeleteProductsDialog = () => {
        setDeleteProductsDialog(false);
    }

    const saveProduct = () => {

        let _teachers = [...teachers];
        let _teacher = { ...emptyTeacher };
        fillTeacher(_teacher)
        _teacher.affiliate.name = selectedAffiliate.name;
        // _teacher.affiliate.contacts.phone1 = selectedAffiliate.contacts.phone1;
        //_teacher.affiliate.contacts.mobile = selectedAffiliate.contacts.mobile;
        //_teacher.affiliate.contacts.email = selectedAffiliate.contacts.email;
        //_teacher.affiliate.grade.level = selectedAffiliate.grade.level;


        affiliate.id = 0
        affiliate.id = selectedAffiliate.id
        let result = postData(affiliate, _teacher, _teachers)
        toast.current.show({ severity: 'success', summary: t('msg.jkaSuccessful'), detail: t('msg.jkaTeacherCreated'), life: 3000 });

        _teachers.push(_teacher);

        clearTeacher()
        setTeachers(_teachers)
        hideDialog()

    }

    function clearTeacher() {
        /*
        _teacher.id = 0;
        _teacher.affiliate.name = '';
        _teacher.affiliate.contacts.phone1 = '';
        _teacher.affiliate.contacts.mobile = '';
        _teacher.affiliate.contacts.email = '';
        _teacher.affiliate.grade.level = '';
        */
    }

    function fillTeacher(teacher) {
        /*
    _teacher.id = 0;
    _teacher.affiliate.name = selectedAffiliate.name;
    _teacher.affiliate.contacts.phone1 = selectedAffiliate.contacts.phone1;
    _teacher.affiliate.contacts.mobile = selectedAffiliate.contacts.mobile;
    _teacher.affiliate.contacts.email = selectedAffiliate.contacts.email;
    _teacher.affiliate.grade.level = selectedAffiliate.grade.level;
    */
    }

    async function postData(affiliate, _teacher, _teachers) {
        try {
            const res = await apiFetch(properties.baseURL + properties.teachersPath, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(affiliate),
            });
            if (!res.ok) {
                const message = `An error has occured: ${res.status} - ${res.statusText}`;
                throw new Error(message);
            }
            const data = res.json();

            const result = {
                status: res.status + "-" + res.statusText,
                headers: {
                    "Content-Type": res.headers.get("Content-Type"),
                    "Content-Length": res.headers.get("Content-Length"),
                },
                data: data,
            };
            console.log(result);

        } catch (err) {
            console.log(err.message);
        }
    }


    const editProduct = (teacher) => {
        setTeacher({ ...teacher });
        setProductDialog(true);
    }

    const confirmDeleteProduct = (teacher) => {
        setTeacher(teacher);
        setDeleteProductDialog(true);
    }

    const deleteProduct = () => {
        let _products = teachers.filter(val => val.id !== teacher.id);
        setProducts(_products);
        delProducts(teacher.id)
        setDeleteProductDialog(false);
        setTeacher(emptyTeacher);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    }


    const delProducts = (id) => {
        apiFetch(`${properties.baseURL}${properties.teachersPath}/${id}`, { method: 'DELETE' });
    }


    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const createId = () => {
        let id = '';
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const confirmDeleteSelected = () => {
        setDeleteProductsDialog(true);
    }

    const deleteSelectedProducts = () => {
        let _products = products.filter(val => !selectedProducts.includes(val));
        setProducts(_products);
        setDeleteProductsDialog(false);
        setSelectedProducts(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    }

    const onCategoryChange = (e) => {
        let _teacher = { ...teacher };
        _teacher['category'] = e.value;
        setTeacher(_teacher);
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _teacher = { ...teacher };
        _teacher[`${name}`] = val;

        setTeacher(_teacher);
    }

    const onInputNumberChange = (e, name) => {
        const val = e.value || 0;
        let _teacher = { ...teacher };
        _teacher[`${name}`] = val;

        setTeacher(_teacher);
    }

    const imageBodyTemplate = (rowData) => {
        return <img src={`demo/images/product/${rowData.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={rowData.image} className="w-7rem shadow-2" />
    }

    const priceBodyTemplate = (rowData) => {
        return formatCurrency(rowData.price);
    }

    const ratingBodyTemplate = (rowData) => {
        return <Rating value={rowData.rating} readOnly cancel={false} />;
    }

    const phoneBodyTemplate = (value) => {
        if (!value) return '';
        if (isValidE164(value)) return formatPhoneForDisplay(value);
        return <span>{value} <i className="pi pi-exclamation-triangle" style={{ color: '#f59e0b' }} title="Telefone não validado" /></span>;
    };

    const statusBodyTemplate = (rowData) => {
        return <span className={`product-badge status-${rowData.inventoryStatus.toLowerCase()}`}>{rowData.inventoryStatus}</span>;
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteProduct(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
            <span className="p-input-icon-left w-full md:w-auto">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="w-full lg:w-auto" />
            </span>
            <div className="mt-3 md:mt-0 flex justify-content-end">
                <Button icon="pi pi-plus" className="mr-2 p-button-rounded" onClick={openNew} tooltip="Novo professor afiliado nao faixa preta" tooltipOptions={{ position: 'bottom' }} />
                <Button icon="pi pi-plus" className="mr-2 p-button-rounded" onClick={openNewBlackBelt} style={{ background: '#000', borderColor: '#000' }} tooltip="Novo professor afiliado faixa preta" tooltipOptions={{ position: 'bottom' }} />
                <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-rounded" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} tooltip="Delete" tooltipOptions={{ position: 'bottom' }} />
                <Button icon="pi pi-upload" className="p-button-help p-button-rounded" onClick={exportCSV} tooltip="Export" tooltipOptions={{ position: 'bottom' }} />
            </div>
        </div>
    );
    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" onClick={saveProduct} />
        </React.Fragment>
    );

    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
        </React.Fragment>
    );

    const deleteProductsDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductsDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedProducts} />
        </React.Fragment>
    );

    return (
        <div className="datatable-crud-demo surface-card p-4 border-round shadow-2">
            <Toast ref={toast} />
            <div className="text-3xl text-800 font-bold mb-4">{t('msg.jkaProfessors')}</div>
            <DataTable ref={dt} value={teachers} selection={selectedTeachers} onSelectionChange={(e) => setSelectedTeachers(e.value)}
                dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={t('currentPageReportTemplate')}
                globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                <Column field="id" header="id professor" sortable style={{ minWidth: '16rem' }}></Column>

                <Column field="affiliate.id" header="id affiliado" sortable style={{ minWidth: '16rem' }}></Column>

                <Column field="affiliate.name" header="Name" sortable style={{ minWidth: '16rem' }}></Column>
                <Column field="affiliate.grade.level" header="Graduacao" sortable style={{ minWidth: '3rem' }}></Column>
                <Column field="affiliate.contacts.phone1" header="Telefone" sortable style={{ minWidth: '4rem' }}
                    body={(row) => phoneBodyTemplate(row.affiliate?.contacts?.phone1)}></Column>
                <Column field="affiliate.contacts.mobile" header="Celular" sortable style={{ minWidth: '4rem' }}
                    body={(row) => phoneBodyTemplate(row.affiliate?.contacts?.mobile)}></Column>
                <Column field="affiliate.contacts.email" header="Email" sortable style={{ minWidth: '16rem' }}></Column>
                <Column field="gym" header="Dojo" sortable style={{ minWidth: '16rem' }}></Column>


                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
            </DataTable>

            <Dialog visible={productDialog} breakpoints={{ '800px': '75vw', '500px': '100vw' }} style={{ width: '30vw' }} header={dialogHeader} modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                {teacher.image && <img src={`demo/images/product/${teacher.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={teacher.image} className="block mt-0 mx-auto mb-5 w-20rem shadow-2" />}


                <div className="field dropdown col-12">
                    <label htmlFor="jkaProfessor"> {t('msg.jkaProfessor')} </label>
                    <Dropdown value={selectedAffiliate} options={affiliates} onChange={onAffiliateChange}
                        optionLabel="name" />
                </div>



            </Dialog>

            <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {teacher && <span>Are you sure you want to delete <b>{teacher.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {teacher && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>
        </div>
    );
}

export default Teachers;